import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const GalleryGrid = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`gallery-grid py-100 xlscreen:py-75 mdscreen:py-50 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-md"
          >
            {module?.grids && (
              <div className="grid grid-cols-2 mdscreen2:grid-cols-1 gap-x-50 gap-y-65 mdscreen2:gap-y-35">
                {module?.grids.map((item, i) => {
                  // Determine if the link is internal or external
                  const isInternal = item?.link?.url && item.link.url.startsWith("/");
                  const Wrapper = isInternal ? Link : "a";
                  const wrapperProps = isInternal
                    ? { to: item.link.url }
                    : { href: item.link.url, target: item.link.target || "_blank", rel: "noopener noreferrer" };

                  return (
                    <div key={i} className="h-full">
                      {item?.link ? (
                        <motion.div
                          variants={animFade}
                          className="item_wrapper h-full w-full border-bg-offwhite"
                        >
                          <Wrapper {...wrapperProps} className="block h-full w-full">
                            <div className="img">
                              <ImageOpt
                                imgData={item.image.mediaItemUrl}
                                imgAlt={item.image.title}
                                imgClass="mx-auto"
                                width={2000}
                                height={1000}
                                imgLoad="lazy"
                              />
                              <div className="caption absolute top-50per translate-y-minus_50 left-0 w-full z-10 container-fluid-sm">
                                <motion.div
                                  variants={animFade}
                                  className="title title-white"
                                >
                                  {item?.link && (
                                    <h3 className="uppercase text-center font-500">
                                      {item.link.title}
                                    </h3>
                                  )}
                                </motion.div>
                              </div>
                            </div>
                          </Wrapper>
                        </motion.div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default GalleryGrid
export const PageGalleryGridFragment = graphql`
  fragment PageGalleryGridFragment on WpPage_Pagecontent_PageContent_GalleryGrid {
    extraClass
    extraId
    hideSection
    grids {
      image {
        altText
        mediaItemUrl
        title
      }
      link {
        target
        title
        url
      }
    }
  }
`